import { initBridget } from './bridge/index.js'

initBridget()
